import {getVersion, runElectronFunc} from "./comm";
import {openExternalLink} from "./window";
import {n2v} from "../Often";

const download = (props) => {
    if(window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'fileDownload', props)
    else fn_fileDownloadForElectron(props.url, '_blank')
}
const autoUpdate = (props) => {
    if (window.ElectronDownloadApi) runElectronFunc('ElectronDownloadApi', 'autoUpdate', props)
    else autoUpdateOnForElectron();
}
const checkFlowNewVersion = () => {
    Company.drawServiceBlock(BLOCK_TYPE.STOP_FLOWNEW, function () {
        DownloadApp.desktopDownloadDirect();
        window.close();
    }, '');
    $("#tempPopup").addClass("serviceStop");
}
const checkFlowVersion = () => {
    var userOs = DownloadApp.userOsCheck();
    DownloadApp.desktopDownloadDirect(userOs, '', async function (updateRec) {

        const electronVersion = n2v(await getVersion(), '3_1_1');
        const isBetaVersion = electronVersion.indexOf('beta') > -1
        let currentVersion = electronVersion.replace(/_/gi, "")
            , currentVerWithComma = electronVersion.replace(/[^0-9|_]/g, '').replace(/_/g, '.').trim()
            , isMinimumVersion = parseInt(currentVersion)  < parseInt(updateRec.flow_rec[0]?.MINI_VER.replace(/\./ig, "").trim())
            , isUnderSelectVer = parseInt(currentVersion)  < parseInt(updateRec.flow_rec[0]?.SELECT_VER.replace(/\./ig, "").trim())

        if (!isMinimumVersion && !isUnderSelectVer && !isBetaVersion) return;
        let helpLinkUrl = getHelpLinkUrl(userOs === 'WINDOWS')
            , contentsInfo = isMinimumVersion ? BLOCK_TYPE.DESKTOP_FORCE_UPDATE : BLOCK_TYPE.DESKTOP_SELECT_UPDATE;

        if (ServerChecker.isKyowon) contentsInfo = BLOCK_TYPE.KYWON_DESKTOP_UPDATE
        if (isMinimumVersion) {
            contentsInfo.main = i18next.t(electron.versionReleased) + '\n' +
                i18next.t(electron.updateRequire) + '\n' +
                i18next.t(electron.currentVersion) + ` &#58; Ver ${currentVerWithComma} \n` +
                i18next.t(electron.latestVersion) + ` &#58; Ver ${updateRec.flow_rec[0].MINI_VER}`,
                Company.drawServiceBlock(contentsInfo, function () {
                    download({url: updateRec.flow_rec[0].LINK_URL, fileName: '_blank'});
                }, '', helpLinkUrl);
        } else {
            contentsInfo.main = i18next.t(electron.versionReleased) + '\n' +
                i18next.t(electron.updateRequire) + '\n' +
                i18next.t(electron.currentVersion) + ` &#58; Ver ${currentVerWithComma} \n` +
                i18next.t(electron.latestVersion) + ` &#58; Ver ${updateRec.flow_rec[0].SELECT_VER}`,
                Company.drawServiceBlock(contentsInfo, function () {
                    download({url: updateRec.flow_rec[0].LINK_URL, fileName: '_blank'});
                }, '', helpLinkUrl);
        }
    });
}

const getHelpLinkUrl = (isWindows) => {
    let helpLinkUrl = '';
    if(Often.isGlobal()){
        let flowLang = Often.null2Void(Often.getCookie("FLOW_LANG"), 'en_uk');
        switch (flowLang) {
            case "ja" :
                helpLinkUrl = "https://support.morningmate.com/ja/articles/7206161";
                break;
            default :
                helpLinkUrl = "https://support.morningmate.com/en/articles/7206161";
        }
    } else {
        helpLinkUrl = isWindows? 'https://support.flow.team/hc/ko/articles/4408449610265' : 'https://support.flow.team/hc/ko/articles/360038630092-Mac';
    }
    return helpLinkUrl;
}


export {
    download,
    autoUpdate,
    checkFlowVersion,
    checkFlowNewVersion
};
